module.exports = __webpack_public_path__ + "img/hero-acc.c6880c74.jpg";